import { AsiDropDown } from './asi-dropdown.component';
import { AsiDropdownContainer } from './container/asi-dropdown-container.component';
import {
  Injectable,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  ViewContainerRef,
} from '@angular/core';

import * as nh from '../../native-helper';
import { of, Observable } from 'rxjs';

@Injectable()
export class AsiDropdownService {

  private containers: Array<ComponentRef<AsiDropdownContainer>> = [];

  constructor(private resolver: ComponentFactoryResolver) {
  }

  /**
   *
   * @param asiDropDown The template content of the dropdown
   * @param viewContainerRef The ViewContainerRef of the parent component
   * @param elementRef The parent HTMLElement, where the dropdown should display
   */
  showDropdown(viewContainerRef: ViewContainerRef, elementRef: any, asiDropDown: AsiDropDown): ComponentRef<AsiDropdownContainer> {
    let containerRef: ComponentRef<AsiDropdownContainer> = this.getContainer(viewContainerRef);

    containerRef.instance.injectService(this);
    containerRef.instance.forElement(elementRef);
    containerRef.instance.show(asiDropDown);
    containerRef.instance.setIndex(this.containers.length);
    containerRef.instance.canClose = asiDropDown.canClose;

    containerRef.instance.onClose().subscribe((containerToRemove) => {
      nh.remove(this.containers, (container) => {
        return containerToRemove.index === container.instance.index;
      });
    });

    this.containers.push(containerRef);

    return containerRef;
  }

  canClose(index: number, canClose: Function): Observable<any> {
    if (index >= this.containers.length - 1) {
      if (canClose) {
        return nh.observe(canClose(document.activeElement));
      } else {
        return of(true);
      }
    } else {
      return of(false);
    }
  }

  private getContainer(viewContainerRef : ViewContainerRef): ComponentRef<AsiDropdownContainer> {
    // Create an AsiDropdownContainer
    const asiDropdownContainerFactory: ComponentFactory<AsiDropdownContainer> = this.resolver.resolveComponentFactory(AsiDropdownContainer);
    return viewContainerRef.createComponent(asiDropdownContainerFactory, 0);
  }
}
